/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rate-period[_ngcontent-%COMP%]   dx-date-box[_ngcontent-%COMP%]{width:40px}"];
export { styles as styles };
